import { render, staticRenderFns } from "./linedTextArea.vue?vue&type=template&id=3c720d60&scoped=true&"
import script from "./linedTextArea.vue?vue&type=script&lang=js&"
export * from "./linedTextArea.vue?vue&type=script&lang=js&"
import style0 from "./linedTextArea.vue?vue&type=style&index=0&id=3c720d60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c720d60",
  null
  
)

export default component.exports